import { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomButtonBase } from 'src/components/CustomButtonBase';
import { CustomRadio } from 'src/components/CustomRadio';
import { TruncatedTypography, TYPOGRAPHY_VARIANT } from 'src/components/TruncatedTypography';
import { onlyValidChildren } from 'src/lib/react';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
};
const defaultProps = {
  className: null,
  classes: null,
  title: '',
  description: '',
  children: null,
  selected: false,
  disabled: false,
};

export const ButtonImproveMode = forwardRef(
  (
    { className, classes, title, description, children, onClick, selected, disabled, ...restProps },
    ref
  ) => {
    const styles = useStyles({ classes });

    return (
      <CustomButtonBase
        className={cx(styles.root, className, {
          [styles.selected]: selected,
        })}
        onClick={onClick}
        disabled={disabled}
        ref={ref}
        {...restProps}
      >
        <CustomRadio
          className={styles.radio}
          checked={selected}
          disabled={disabled}
          tabIndex={-1}
        />

        {onlyValidChildren(children).length > 0 ? (
          children
        ) : (
          <div className={styles.content}>
            <TruncatedTypography
              className={styles.title}
              variant={TYPOGRAPHY_VARIANT.regular14}
            >
              {title}
            </TruncatedTypography>

            {description && (
              <TruncatedTypography
                className={styles.description}
                variant={TYPOGRAPHY_VARIANT.regular12}
              >
                {description}
              </TruncatedTypography>
            )}
          </div>
        )}
      </CustomButtonBase>
    );
  }
);

ButtonImproveMode.displayName = 'ButtonRecomposeMode';
ButtonImproveMode.propTypes = propTypes;
ButtonImproveMode.defaultProps = defaultProps;
